// extracted by mini-css-extract-plugin
export default {"input":"EditBadge_input__iAdZY","bottom":"EditBadge_bottom__PgSLc","badge":"EditBadge_badge__OzP1a"};